import React, { useEffect, useState } from "react";
import type { AnswerState, MatchAudioExercise } from "../../types/exercises";
import { ChoiceTile, TileState } from "./ChoiceTile";
import { SpeakButton } from "./SpeakButton";
import { canSpeak, speak } from "../../utils/speech";
interface MatchAudioProps {
  exercise: MatchAudioExercise;
  onAnswer: (a: AnswerState) => void;
  checked: boolean;
  speechLang: string;
}
export function MatchAudio({
  exercise,
  onAnswer,
  checked,
  speechLang
}: MatchAudioProps) {
  const [selected, setSelected] = useState<string | null>(null);
  useEffect(() => {
    const t = window.setTimeout(() => speak(exercise.audio, speechLang), 350);
    return () => window.clearTimeout(t);
  }, [exercise.audio, speechLang]);
  const stateFor = (o: string): TileState => {
    if (checked) {
      if (o === exercise.answer) return "correct";
      if (o === selected) return "wrong";
      return "idle";
    }
    return o === selected ? "selected" : "idle";
  };
  return <div data-id="element-365" data-mp="11o12k1ov0kh">
      <div className="mb-8 flex items-end justify-center gap-4" data-id="element-366" data-mp="12h2d5hvoxv8">
        <SpeakButton text={exercise.audio} lang={speechLang} size="lg" label="Play the word" data-id="element-367" data-mp="13s28u87dlh2" />
        <SpeakButton text={exercise.audio} lang={speechLang} slow data-id="element-368" data-mp="3sal3fy2zxkll" />
      </div>
      {!canSpeak() && <p className="mb-4 text-center text-sm text-ink-2" data-id="element-369" data-mp="3nf5u9jfxocvi">
          Audio isn't available in this browser. The word is: <strong lang="es" data-id="element-370" data-mp="3egkd9sq415wu">{exercise.audio}</strong>
        </p>}
      {checked && <p className="mb-4 text-center text-lg font-bold text-ink" lang="es" data-id="element-371" data-mp="39hqy7vv6d6uk">
          “{exercise.audio}”
        </p>}
      <ul className="grid gap-3 sm:grid-cols-2" data-id="element-372" data-mp="34huttvikfdeh">
        {exercise.options.map(o => <li key={o} data-id="element-373" data-mp="2zk30qy66pl8p">
            <ChoiceTile state={stateFor(o)} disabled={checked} className="w-full" onClick={() => {
          setSelected(o);
          onAnswer({
            ready: true,
            correct: o === exercise.answer,
            solution: `“${exercise.audio}” = ${exercise.answer}`
          });
        }} data-id="element-374" data-mp="2zkuyofn97v25">
              {o}
            </ChoiceTile>
          </li>)}
      </ul>
    </div>;
}